import { ArchiveEditOutlineIcon } from './ArchiveEditOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 18D5853A-26A8-416D-9029-9F216DA3316B
 * name archive-edit-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-edit-outline.svg
 * tags
 * - Edit / Modify 
 */
export const BoxEditOutlineIcon = ArchiveEditOutlineIcon;
export default BoxEditOutlineIcon